export const generateCacheKey = (prefix: string, str: string) => {
  if (!str) return '';
  const val = str.trim();
  return prefix ? `${prefix}_${val}` : val;
};
